// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// Values come from the build machine's environment via scripts/generate-build-env.js.
import { buildEnv } from './build-env';

export const environment = {
  production: buildEnv.PRODUCTION,
  apiUrl: buildEnv.API_URL,
  productUrl: buildEnv.PRODUCT_URL,
  imageUrl: buildEnv.IMAGE_URL,
  clientExtensionAPI: buildEnv.CLIENT_EXTENSION_API,
};
// these are apis for live below
// apiUrl: 'https://signupapi.thinkenergy.plus/',
// productUrl: 'https://signupapi.thinkenergy.plus/',
// imageUrl: 'https://energywell.corpadmin.directscale.com/CMS/Images/Inventory'

//these are stage apis
// apiUrl: 'https://energywellapi.ziplingo.com/',
// productUrl: 'https://energywellapi.ziplingo.com/',
// imageUrl: 'https://energywell.corpadmin.directscale.com/CMS/Images/Inventory'
